<template>
    <div class="report-month-stats">
        <table class="table table-sm table-striped">
            <thead class="thead-dark">
            <tr>
                <th></th>
                <th>Customer Base</th>
                <th>Cancellations</th>
                <th>Churn Rate</th>
                <th>(First) Active</th>
                <th>Revenue</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Scheme To Date</td>
                <td>{{ enrolled.all }}</td>
                <td>{{ cancelled.all }}</td>
                <td>{{ report.churnRates.all }}</td>
                <td>{{ active.all }}</td>
                <td>{{ revenue_all }}</td>
            </tr>
            <tr>
                <td>YTD {{ year }}</td>
                <td>{{ enrolled.ytd }}</td>
                <td>{{ cancelled.ytd }}</td>
                <td>{{ report.churnRates.ytd }}</td>
                <td>{{ active.ytd }}</td>
                <td>{{ revenue_ytd }}</td>
            </tr>
            <tr>
                <td>{{ monthName }} {{ year }}</td>
                <td>{{ enrolled.month }}</td>
                <td>{{ cancelled.month }}</td>
                <td>{{ report.churnRates.month }}</td>
                <td>{{ active.month }}</td>
                <td>{{ revenue_month }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    export default {
        name: "ReportMonth",
        props: ['revenue','enrolled','active','cancelled','year','monthName','report'],
        methods: {
            format_revenue: function(value){
                let formatter = new Intl.NumberFormat('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                });

                return formatter.format(value);
            }
        },
        computed: {
            revenue_all: function() {
                return this.format_revenue(this.revenue.all);
            },
            revenue_ytd: function() {
                return this.format_revenue(this.revenue.ytd);
            },
            revenue_month: function() {
                return this.format_revenue(this.revenue.month);
            }
        }
    }
</script>

<style scoped>
</style>
